<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="-1 -1 18 18"
    fill="none"
    overflow="visible"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM6.50488 11.4951C6.26581 11.256 6.23594 10.8869 6.41504 10.6152L6.50488 10.5049L9.00977 8L6.50488 5.49512L6.41504 5.38477C6.23595 5.1131 6.26581 4.74396 6.50488 4.50488C6.74396 4.26581 7.1131 4.23595 7.38477 4.41504L7.49512 4.50488L10.4951 7.50488C10.7685 7.77825 10.7685 8.22175 10.4951 8.49512L7.49512 11.4951L7.38477 11.585C7.1131 11.7641 6.74396 11.7342 6.50488 11.4951Z"
      fill="currentColor"
    />
  </svg>
</template>
